module.exports = __webpack_public_path__ + "static/appTabImg3-59d6ecf5537d4abf755dd9e45034092c.png";